import { MultiLanguage } from "../../MultiLanguage";
import { PayExemptionTypes } from "../../enum/PayExemptionTypes";

export class PayExemption {
    private _payExemptionType: number;
    private _autonomousCommunity: number;
    private _payExemptionTitle: MultiLanguage | null;
    
    public constructor(data: any, processesConfigurationPayExemptions?: any) {
        this._payExemptionType = data.payExemptionType;
        this._autonomousCommunity = data.autonomousCommunity;
        this._payExemptionTitle = processesConfigurationPayExemptions ? processesConfigurationPayExemptions.filter(processesConfigurationPayExemption => processesConfigurationPayExemption.payExemptionType === data.payExemptionType)[0].title : null;
    }
    
    public get payExemptionType() {
        return this._payExemptionType;
    }
    public set payExemptionType(payExemptionType: number) {
        this._payExemptionType = payExemptionType;
    }

    public get autonomousCommunity() {
        return this._autonomousCommunity;
    }
    public set autonomousCommunity(autonomousCommunity: number | null) {
        this._autonomousCommunity = autonomousCommunity;
    }

    public get payExemptionTitle() {
        return this._payExemptionTitle;
    }

    public isExceptionPaymentFamily() {
        return this._payExemptionType === PayExemptionTypes.enum.GENERALLARGEFAMILY || this._payExemptionType === PayExemptionTypes.enum.SPECIALLARGEFAMILY
    }

    public toServer() {
        return {
            payExemptionType: this._payExemptionType,
            autonomousCommunity: this.isExceptionPaymentFamily ? this._autonomousCommunity : null
        };
    }
}
